import React, { ReactElement } from 'react';
import StructureService from '../../services/structure-service';

const VisibleCell: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement | null => {
  const {
    isFullTable,
    isEditMode,
    withEntity,
    entityType,
    permissionList,
    tableField,
    children,
  } = props;

  const isVisible: boolean = ((tableField.isEditModeOnly && isEditMode) || !tableField.isEditModeOnly)
    && ((tableField.isVisibleByEntity && withEntity) || !tableField.isVisibleByEntity)
    && ((tableField.isVisibleByType && entityType && tableField.isVisibleByType === entityType)
      || !tableField.isVisibleByType || !entityType)
    && ((tableField.isFullTableOnly && isFullTable) || !tableField.isFullTableOnly)
    && ((tableField.permission && StructureService.checkPermission(tableField.permission, permissionList))
      || !tableField.permission)
    && !tableField.isHidden;

  if (!isVisible) {
    return null;
  }

  return children;
});

export default VisibleCell;
